import { DataCollectionInterface } from '../../interfaces/data-collection.interface';

export class UpdateDataCollection {
    public static readonly type = '[DataCollection] Update data collection';

    constructor(public dataCollection: Partial<DataCollectionInterface>) { }
}
